var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('Nav',{attrs:{"list":_vm.headerList}}),_c('div',{ref:"content"},[_c('SingleBanner'),_c('MainContent')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }